import React from "react"
import { Chart } from "react-google-charts"

const majorTicks = max => {
  const increment = Math.floor(max / 5)
  return [0, 1, 2, 3, 4, 5].map(n => n * increment)
}

const Gauge = ({ num, max, monthData: { total, label, bonus, cap } }) => {
  const maxVal = max - max % 50 + 100

  let options = {
    greenFrom: 0,
    greenTo: 0.8 * cap,
    yellowFrom: 0.8 * cap,
    yellowTo: cap,
    redFrom: cap,
    redTo: maxVal,
    minorTicks: 4,
    majorTicks: majorTicks(maxVal),
    min: 0,
    max: maxVal,
  }

  let data = [["Label", "Value"], ["Usage", total]]

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <p>Bandwidth Usage<br /> for {label}</p>
      <Chart
        style={{ margin: "0 auto" }}
        chartType="Gauge"
        width={"200"}
        height={"200"}
        options={options}
        graph_id={"gauge" + num}
        data={data}
      />
    </div>
  )
}

export default Gauge
